// @core/api/endpoints/calendar/get_event_template.ts
// Auto-generated by corebuilder. DO NOT EDIT.

import { getApiClient, type RequestOptions } from '../../client';
import type {
  EventTemplateResponse,
} from '../../../types/calendar';

const BASE_PATH = '/calendar';

/**
 * Get event template
 * Retrieves an event template with all its predefined settings.
 */
export async function GetEventTemplate(
  template_id: string,
  options?: RequestOptions
): Promise<EventTemplateResponse> {
  const client = getApiClient();
  let requestPath = `${BASE_PATH}/event-templates/:template_id`;
  requestPath = requestPath.replace(':template_id', encodeURIComponent(template_id));
  const requestOptions = options;
  return client.get<EventTemplateResponse>(requestPath, { ...requestOptions });
}
